import type { ListParams } from '@/shared/types';

export const cityKeys = {
  all: ['cities'] as const,
  list: (params: ListParams) => ['cities', 'list', params] as const,
  detail: (id: string | number) => ['cities', 'detail', id] as const,
  countries: ['cities', 'countries'] as const,
  regionsByCountry: (countryId: number) => ['cities', 'regions', countryId] as const,
};
